import { persistedReducer as adminDeflectAnalytics } from "./Containers/AdminDeflectAnalyticsPage/redux/adminDeflectAnalytics.slice"
import { persistedReducer as adminInvoices } from "./Containers/AdminInvoicesPage/redux/adminInvoices.slice"
import { persistedReducer as adminUsers } from "./Containers/AdminUsersPage/redux/adminUsers.slice"
import { persistedReducer as alerts } from "./Containers/AlertsPage/redux/alerts.slice"
import { persistedReducer as balance } from "./Containers/Balance/redux/balance.slice"
import { persistedReducer as businessAccounts } from "./Containers/BusinessAccountsPage/redux/businessAccounts.slice"
import { reducer as businessDetails } from "./Containers/BusinessDetailsBlock/redux/businessDetails.slice"
import { reducer as creditsAutomation } from "./Containers/CreditsAutomationPage/redux/creditsAutomation.slice"
import { reducer as creditAutomation } from "./Containers/CreditsPage/redux/creditAutomation.slice"
import { persistedReducer as credits } from "./Containers/CreditsPage/redux/credits.slice"
import { persistedReducer as dashboard } from "./Containers/DashboardPage/redux/dashboard.slice"
import { persistedReducer as deflectAnalytics } from "./Containers/DeflectAnalyticsPage/redux/deflectAnalytics.slice"
import { persistedReducer as globalFilters } from "./Containers/GlobalFilters/redux/globalFilters.slice"
import { persistedReducer as health } from "./Containers/Health/redux/health.slice"
import { persistedReducer as home } from "./Containers/HomePage/redux/home.slice"
import { persistedReducer as invoices } from "./Containers/InvoiceHistoryBlock/redux/invoices.slice"
import { persistedReducer as auth } from "./Containers/LoginPage/redux/auth.slice"
import { persistedReducer as marketing } from "./Containers/MarketingPage/redux/marketing.slice"
import { reducer as paymentMatching } from "./Containers/PaymentMatchingPage/redux/paymentMatching.slice"
import { persistedReducer as perksAdmin } from "./Containers/PerksAdminPage/redux/perksAdmin.slice"
import { reducer as perks } from "./Containers/PerksPage/redux/perks.slice"
import { persistedReducer as publicApi } from "./Containers/PersonalSettings/PublicAPI/redux/publicApi.slice"
import pricing from "./Containers/PricingPage/redux/pricing.slice"
import { persistedReducer as receiptCompellingEvidence } from "./Containers/ReceiptPage/CompellingEvidencePage/redux/compelling-evidence.slice"
import { persistedReducer as receiptBusiness } from "./Containers/ReceiptPage/ConfigureBusinessPage/redux/business.slice"
import { persistedReducer as receiptConfigure } from "./Containers/ReceiptPage/ConfigureProfilePage/redux/configure.slice"
import { persistedReducer as receipt } from "./Containers/ReceiptPage/redux/receipt.slice"
import { persistedReducer as referrals } from "./Containers/Referrals/redux/referrals.slice"
import { reducer as requests } from "./Containers/RequestsPage/redux/requests.slice"
import { persistedReducer as requestsAutoRefund } from "./Containers/RequestsPage/RequestsAutoRefund/redux/requestsAutoRefund.slice"
import { reducer as requestsEnrollments } from "./Containers/RequestsPage/RequestsEnrollments/redux/requestsEnrollments.slice"
import { persistedReducer as requestsGifts } from "./Containers/RequestsPage/RequestsGifts/redux/requestsGifts.slice"
import { persistedReducer as requestsIntegrations } from "./Containers/RequestsPage/RequestsIntegrations/redux/requestsIntegrations.slice"
import { reducer as requestsReceipts } from "./Containers/RequestsPage/RequestsReceipts/redux/requestsReceipts.slice"
import { persistedReducer as requestsVerifiInform } from "./Containers/RequestsPage/RequestsVerifiInform/redux/requestsVerifiInform.slice"
import { persistedReducer as requestsWithdrawal } from "./Containers/RequestsPage/RequestsWithdrawal/redux/requestsWithdrawal.slice"
import { persistedReducer as setting } from "./Containers/Setting/redux/setting.slice"
import { reducer as shopifyMove } from "./Containers/ShopifyMove/redux/shopifyMove.slice"
import { persistedReducer as user } from "./Containers/User/redux/user.slice"
import { persistedReducer as users } from "./Containers/UsersPage/redux/users.slice"
import { persistedReducer as nav } from "./Redux/nav/nav.slice"
import { persistedReducer as errors } from "./Redux/redux/errors.slice"

export const reducers = {
  auth,
  nav,
  errors,
  user,
  dashboard,
  alerts,
  home,
  setting,
  shopifyMove,
  users,
  businessAccounts,
  adminUsers,
  requestsEnrollments,
  requestsAutoRefund,
  requestsIntegrations,
  requestsGifts,
  requestsWithdrawal,
  requestsReceipts,
  requestsVerifiInform,
  receipt,
  receiptConfigure,
  receiptBusiness,
  receiptCompellingEvidence,
  deflectAnalytics,
  adminDeflectAnalytics,
  adminInvoices,
  pricing,
  invoices,
  globalFilters,
  credits,
  creditAutomation,
  creditsAutomation,
  balance,
  marketing,
  requests,
  referrals,
  businessDetails,
  publicApi,
  health,
  perks,
  paymentMatching,
  perksAdmin
}

export default reducers
